import styled from 'styled-components'

export const FilterContentWrapper = styled.div`
    padding: 0 1rem;
    width: 100%;
`

export const LoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 1rem 1rem 0 0;
    background: rgba(255, 255, 255, 0.8);
    z-index: 9999;
    pointer-events: none;
`

export const SpinnerWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10000;
    pointer-events: none;
`
